import { ETasksSortableKey } from 'services/TaskManagementApi/types/TaskManagementResponse';
import { ESortOrder } from 'store/common/types';
import { IFilter } from 'services/CrmApi/types/DirectoryEntry';

export interface ICrmDomain {
  filters: IFilter,
  confirmedFilters: IFilter,
  data: {
    managerText: string;
    isDirtyEditCompanyProfile: boolean;
    isDirtyEditContactProfile: boolean;
  },
  pagination: {
    currentPage: number;
    itemsPerPage: number; 
    totalItems: number | null; 
  },
  sort: {
    sortBy: ETasksSortableKey;
    sortOrder: ESortOrder; 
  },
  subscription: {
    subscribeModalOpen: boolean;
    unsubscribeModalOpen: boolean;
    isPending: boolean;
  },
}

export const initialState: ICrmDomain = {
  filters: {
    term: '',
    typeCodes: [],
    managerId: null,
    countryCodes: [],
    leadStageCode: null,
    leadScoreGte: null,
    bookingActivityStatus: null,
  },
  confirmedFilters: {
    term: '',
    typeCodes: [],
    managerId: null,
    countryCodes: [],
    leadStageCode: null,
    leadScoreGte: null,
    bookingActivityStatus: null,
  },
  data: {
    managerText: '',
    isDirtyEditCompanyProfile: false,
    isDirtyEditContactProfile: false,
  },
  pagination: {
    currentPage: 0,
    itemsPerPage: 10,
    totalItems: null,
  },
  sort: {
    sortBy: ETasksSortableKey.DEADLINE,
    sortOrder: ESortOrder.ASC,
  },
  subscription: {
    subscribeModalOpen: false,
    unsubscribeModalOpen: false,
    isPending: false,
  }
};
